import { LitElement, html, css } from 'lit'
import { consume } from '@lit/context'
import { breakpointContext, isOutletNavigationOpenContext, isSubMenuOpenContext } from '../context.ts'
import { customElement } from 'lit/decorators.js'
import { TW, type Breakpoint } from '../../../shared'

const TwLitElement = TW(LitElement)

/**
 * Sample Lit Element in assets/lit
 */
@customElement('button-open-menu')
export class ButtonOpenMenu extends TwLitElement {

    @consume({context: breakpointContext, subscribe: true}) 
    private _breakpoint: Breakpoint | null = null

    @consume({context: isSubMenuOpenContext, subscribe: true})
    private _isSubMenuOpen: boolean = false

    @consume({context: isOutletNavigationOpenContext, subscribe: true})
    private _isOutletNavigationOpen: boolean = false

    static styles = css`
        :host([hidden]) {
            display: none;
        }
    `

    /**
     * Nur auf mobile zeigen, wenn das Submenu nicht offen ist
     */
    private _isShown() {
        return ! this._isSubMenuOpen 
            && ! this._isOutletNavigationOpen
            && [ 'xs', 'sm', 'md', 'lg', 'xl', '2xl', '3xl' ].includes( this._breakpoint?.name ?? '' ) // Wann soll die Navigation angezeigt werden?
    }

    private _onClick(event: Event) { console.log('onClick');
        event.preventDefault();
        event.stopPropagation();
        this.dispatchEvent( new CustomEvent( 'bmw-header-open-sub-menu', { bubbles: true, composed: true } ) )
    }

    render() 
    {
        if ( ! this._isShown() ) {
            this.setAttribute( 'hidden', '' );
            return html``
        }

        this.removeAttribute( 'hidden' );

        return this._isSubMenuOpen
            ? html`<div class="wp-button is-bmw-icon is-bmw-icon-close-rg"><button @click=${this._onClick} class="wp-element-button block cursor-pointer w-[60px] h-[60px] before:text-[33px]!" aria-label="Hauptmenü schließen" aria-expanded="true" aria-haspopup="menu"></button></div>`
            : html`<div class="wp-button is-bmw-icon is-bmw-icon-menu-rg"><button @click=${this._onClick} class="wp-element-button block cursor-pointer w-[60px] h-[60px] before:text-[33px]!" aria-label="Hauptmenü öffnen" aria-expanded="false" aria-haspopup="menu"></button></div>`
    }
}

declare global {
    interface HTMLElementTagNameMap {
        'button-open-menu': ButtonOpenMenu
    }
}
